export const ACCOUNT_SETTINGS_ROUTES = {
  root: "/account-settings",
  profile: "/account-settings/profile",
  trips: "/account-settings/trips",
  enquiry: "/account-settings/enquiry",
  favorites: "/favorites",
  vouchers: "/account-settings/vouchers",
  companions: "/account-settings/companions",
  security: "/account-settings/security",
  preferences: "/account-settings/preferences",
  deals: "/account-settings/deals",
  partner: "/partner",
  invite: "/account-settings/invite",
  delete: "/account-settings/delete",
} as const;
